

























  import {Component, Vue, Watch} from 'vue-property-decorator'
import {routes} from "@/router";
import kepler from "../../lib/kepler_sdk/kepler";
import notifications from "../../lib/notifications";

@Component({
  components: {
  },
})
export default class LoginPage extends Vue {

  public login:any = {
    username: null,
    password: null,
  }
  public isValid: boolean = true
  public loginIncorrect : boolean = false
  public  loginIncorrectMessage:string = ''

    @Watch('login')
    private loginHandler() {
      let self = this;
        kepler.post('login', this.login)!.then((response) => {
          localStorage.setItem('argo-token', response.data.api_token)
          //alert(JSON.stringify(response))
          self.$router.push({name: 'dashboard'})
        }).catch(error => this.handleError(error))

    }
    public handleError(error:any) {
     //alert(error.response.status + ": " + JSON.stringify(error.response.data, null, 2))
      this.loginIncorrect = true
      this.loginIncorrectMessage = error.response.status + ": " + JSON.stringify(error.response.data, null, 2)


    }
  public notifyError(error: any) {
    notifications.notify("error", error.response.status + ": " + JSON.stringify(error.response.data, null, 2))
  }
}

